<template>
  <div class="container">
    <h1 class="h1">Cost Limit</h1>
    <div class="row margin-bottom-2">
      <div class="col">
        Limit your cost for your subscription per month or day.
        <sdx-menu-flyout>
          <sdx-menu-flyout-toggle>
            <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
          </sdx-menu-flyout-toggle>
          <sdx-menu-flyout-content style="width: 600px;">
            <p>
              1. limit period will start after setting the limitations.
            </p>
          </sdx-menu-flyout-content>
        </sdx-menu-flyout>
        <br/>
        We will inform you by email when you reach the cost limit.<br/>
        When the limit is reached, all outgoing SMS will be blocked until the end of the actual period.
      </div>
    </div>
    <div class="row margin-bottom-3">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged"/>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-costlimit" size="large" sr-hint="Loading. Please wait."
                         class="spinner-dashboard"></sdx-loading-spinner>
    <div id="costLimit" v-if="showCostLimit">
      <div class="row margin-bottom-1">

        <div class="col col-xs-6" v-if="costLimitNational && productCategory!='Free'">
          <div id="barCostLimitNational" data-testid="barCostLimitNational" class="loader-bar">
            <div class="detail" style="vertical-align: bottom;">
              <div class="name cost-limit-bar-title">National</div>
              <div class="detail-right">
                <div class="progress">used {{ actualCostNational }}</div>
                <div class="file-size">of {{ costLimitNational }} {{ getCostUnit }} per {{ costPeriode }}</div>
              </div>
            </div>
            <div class="loader-bar--progress cost-limit-bar">
              <div class="indicator"
                   :class="(actualCostNational>=costAlarmNational?(actualCostNational>=costLimitNational?'cost-limit':'cost-alarm'):'')"
                   :style="'width: '+(actualCostNational/costLimitNational*100)+'%;'"></div>
            </div>
            <div>
              <span v-if="actualCostAlarmNationalSent" class="infoCostAlarm">Alarm: {{ actualCostAlarmNationalSent }}<br/></span>
              <span v-if="actualCostLimitNationalSent" class="infoCostLimit">Blocked:  {{ actualCostLimitNationalSent }}<br/></span>
            </div>
            <div>
              <span v-if="costLimitNationalByProduct">
              No specific cost limit for national sending is defined!<br/>
              Default product limits are applied.
              </span>
            </div>
          </div>
        </div>
        <div class="col col-xs-6" v-if="productCategory=='Free'">
          <div class="name cost-limit-bar-title">National</div>
          Free subscriptions are limited by quota.
        </div>

        <div class="col col-xs-6" v-if="costLimitInternational && productCategory!='Free'">
          <div id="barCostLimitInternational" data-testid="barCostLimitInternational" class="loader-bar">
            <div class="detail">
              <div class="name cost-limit-bar-title">International</div>
              <div class="detail-right">
                <div class="progress">used {{ actualCostInternational }}</div>
                <div class="file-size">of {{ costLimitInternational }} {{ getCostUnit }} per {{ costPeriode }}</div>
              </div>
            </div>
            <div class="loader-bar--progress cost-limit-bar">
              <div class="indicator"
                   :class="(actualCostInternational>=costAlarmInternational?(actualCostInternational>=costLimitInternational?'cost-limit':'cost-alarm'):'')"
                   :style="'width: '+(actualCostInternational/costLimitInternational*100)+'%;'"></div>
            </div>
          </div>
          <div>
            <div>
              <span v-if="actualCostAlarmInternationalSent" class="infoCostAlarm">Alarm: {{ actualCostAlarmInternationalSent }}<br/></span>
              <span v-if="actualCostLimitInternationalSent" class="infoCostLimit">Blocked:  {{ actualCostLimitInternationalSent }}<br/></span>
            </div>
            <span v-if="costLimitNationalByProduct">
            No specific cost limit for international sending is defined!<br/>
            Default product limits are applied.
            </span>
          </div>
        </div>
        <div class="col col-xs-6" v-if="productCategory=='Free'">
          <div class="name cost-limit-bar-title">International</div>
          Free subscriptions are limited by quota.
        </div>

      </div>
      <sdx-expand-and-collapse v-if="productCategory!='Free'"
                               data-testid="expandFormular"
                               expand-label="Adapt cost limits"
                               collapse-label="Adapt cost limits">
        <div class="row">
          <div class="col margin-bottom-1">
            <div className="row">
              <div className="col-md-6 margin-bottom-2">
                <span class="sdx-like-label" style="padding-right: 5px">Cost Alarm National [{{ getCostUnit }}]</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>
                      Email will be sent if usage is reaching this limit.
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
                <sdx-input
                    data-testid="costAlarmNational"
                    name="costAlarmNational"
                    className="sdx-input"
                    type="number"
                    inputmode="decimal"
                    placeholder="Define your alarm..."
                    :value="costAlarmNational"
                    @input="costAlarmNational=$event.target.value"
                    :validation-message="!validateCostAlarmNational() ? 'Cost alarm national must be smaller or equal to limit.' : ''"></sdx-input>
              </div>
              <div className="col-md-6 margin-bottom-2">
                <span class="sdx-like-label" style="padding-right: 5px">Cost Alarm International [{{
                    getCostUnit
                  }}]</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>
                      Email will be sent if usage is reaching this limit.
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
                <sdx-input
                    data-testid="costAlarmInternational"
                    name="costAlarmInternational"
                    className="sdx-input"
                    type="number"
                    inputmode="decimal"
                    placeholder="Define your alarm..."
                    :value="costAlarmInternational"
                    @input="costAlarmInternational=$event.target.value"
                    :validation-message="!validateCostAlarmInternational() ? 'Cost alarm international must be smaller or equal to limit.' : ''"></sdx-input>
              </div>
            </div>

            <div className="row margin-bottom-1">
              <div className="col-md-6 margin-bottom-2">
                <span class="sdx-like-label" style="padding-right: 5px">Cost Limit National [{{
                    getCostUnit
                  }}]</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>
                      Subscription will be blocked for any further national sending of SMS for the actual period.<br/>
                      Also an email will be sent to inform about.
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
                <sdx-input
                    data-testid="costLimitNational"
                    name="costLimitNational"
                    className="sdx-input"
                    type="number"
                    inputmode="decimal"
                    placeholder="Define your limit..."
                    :value="costLimitNational"
                    @input="costLimitNational=$event.target.value"></sdx-input>
              </div>
              <div className="col-md-6">
                <span class="sdx-like-label" style="padding-right: 5px">Cost Limit International [{{
                    getCostUnit
                  }}]</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>
                      Subscription will be blocked for any further international sending of SMS for the actual
                      period.<br/>
                      Also an email will be sent to inform about.
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
                <sdx-input
                    data-testid="costLimitInternational"
                    name="costLimitInternational"
                    className="sdx-input"
                    type="number"
                    inputmode="decimal"
                    placeholder="Define your limit..."
                    :value="costLimitInternational"
                    @input="costLimitInternational=$event.target.value"></sdx-input>
              </div>
            </div>

            <hr class="divider divider--light-gray margin-top-1 margin-bottom-1"/>

            <div className="row margin-top-2 margin-bottom-4">
              <div className="col-md-2">
                <span class="sdx-like-label"
                      style="padding-right: 5px">Limit per month or per day</span>
                <sdx-select
                    id="costPeriodeDropDown"
                    data-testid="costPeriodeDropDown"
                    :value="costPeriode"
                    @input="costPeriode = $event.target.value[0]">
                  <sdx-select-option
                      data-testid="costPeriodeDropDownMonth"
                      key="Month"
                      value="Month"
                      :selected="isSelectedPeriode('Month')">Month
                  </sdx-select-option>
                  <sdx-select-option
                      data-testid="costPeriodeDropDownDay"
                      key="Day"
                      value="Day"
                      :selected="isSelectedPeriode('Day')">Day
                  </sdx-select-option>
                </sdx-select>
              </div>

              <div className="col col-md-10">
                <span class="sdx-like-label" style="padding-right: 5px">Emails</span>
                <sdx-menu-flyout>
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>
                      Comma separated list of emails, which are informed.
                    </p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
                <sdx-input
                    data-testid="costEmail"
                    name="costEmail"
                    className="sdx-input"
                    placeholder="A valid email list..."
                    :value="costEmail"
                    @input="costEmail=$event.target.value"
                    :validation-message="(costEmail!='' && !validateCostEmail()) ? 'The email list you entered is not valid.' : ''"></sdx-input>
                <sdx-button
                    data-testid="buttonAddOwnersEmail"
                    name="buttonAddOwnersEmail"
                    label="Add owners email"
                    theme="secondary"
                    icon-name="icon-email-sent"
                    size="small"
                    class="align-right margin-top-1"
                    @click="addOwnersEmail()"></sdx-button>
              </div>
            </div>

            <div className="row">
              <div className="col margin-bottom-1">
                <sdx-button-group className="align-right">
                  <sdx-button
                      data-testid="buttonSave"
                      name="buttonSave"
                      label="Save"
                      :disabled="!this.validateForm()"
                      @click="save()"></sdx-button>
                </sdx-button-group>
              </div>
            </div>
          </div>
        </div>
      </sdx-expand-and-collapse>
    </div>
  </div>
</template>

<script>
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent.vue";
import loadingSpinnerService from '@/services/loading-spinner.service';
import costLimitService from '../service'
import {logger} from "@/services/logger.service";
import userService from "@/services/user.service";
import {showAlert, showSuccess} from "@/services/notification.service";
import {validateEmail} from "@/util/utility";

export default {
  components: {
    DevAppDropDownComponent
  },
  data: function () {
    return {
      webId: undefined,
      showCostLimit: false,
      costLimitNationalByProduct: false,
      costLimitInternationalByProduct: false,
      productCategory: undefined,

      actualCostNational: undefined,
      actualCostInternational: undefined,
      actualCostAlarmNationalSent: undefined,
      actualCostLimitNationalSent: undefined,
      actualCostAlarmInternationalSent: undefined,
      actualCostLimitInternationalSent: undefined,

      costAlarmNational: undefined,
      costLimitNational: undefined,
      costAlarmInternational: undefined,
      costLimitInternational: undefined,
      costPeriode: "Month",
      costEmail: undefined
    }
  },
  async mounted() {
    loadingSpinnerService.hide("costlimit");
  },
  computed: {
    isAdmin() {
      return userService.isAtLeastAdminWithoutFmg();
    },
    getCostUnit() {
      return (this.productCategory == "Business" ? "CHF" : "SMS")
    }
  },
  methods: {
    async devAppChanged(webId) {
      loadingSpinnerService.show("costlimit")
      this.webId = webId;
      await this.loadCostLimit();
      loadingSpinnerService.hide("costlimit")
    },
    async loadCostLimit() {
      this.showCostLimit = false
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showCostLimit = false
      } else {
        try {
          let response = await costLimitService.getCostLimit(this.webId)
          this.actualCostNational = response.data.actualCostNational;
          if (this.actualCostNational === undefined) {
            this.actualCostNational = 0;
          }
          this.costAlarmNational = response.data.costAlarmNational;
          if (this.costAlarmNational === undefined) {
            this.costAlarmNational = response.data.productCostLimit.costAlarmNational;
          }
          this.costLimitNational = response.data.costLimitNational;
          if (this.costLimitNational === undefined) {
            this.costLimitNationalByProduct = true;
            this.costLimitNational = response.data.productCostLimit.costLimitNational;
          } else {
            this.costLimitNationalByProduct = false;
          }
          this.actualCostInternational = response.data.actualCostInternational;
          if (this.actualCostInternational === undefined) {
            this.actualCostInternational = 0;
          }
          this.costAlarmInternational = response.data.costAlarmInternational;
          if (this.costAlarmInternational === undefined) {
            this.costAlarmInternational = response.data.productCostLimit.costAlarmInternational;
          }
          this.costLimitInternational = response.data.costLimitInternational;
          if (this.costLimitInternational === undefined) {
            this.costLimitInternationalByProduct = true;
            this.costLimitInternational = response.data.productCostLimit.costLimitInternational;
          } else {
            this.costLimitInternationalByProduct = false;
          }
          this.productCategory = response.data.productCategory;
          this.costPeriode = response.data.costPeriode;
          if (this.costPeriode === undefined) {
            if (response.data.productCostLimit.costPeriode) {
              this.costPeriode = response.data.productCostLimit.costPeriode;
            } else {
              this.costPeriode = "Month";
            }
          }
          this.costEmail = response.data.costEmail;
          if (this.costEmail === undefined) {
            this.costEmail = response.data.productCostLimit.costEmail;
          }
          this.actualCostAlarmNationalSent = response.data.actualCostAlarmNationalSent;
          this.actualCostLimitNationalSent = response.data.actualCostLimitNationalSent;
          this.actualCostLimitInternationalSent = response.data.actualCostLimitInternationalSent;
          this.actualCostAlarmInternationalSent = response.data.actualCostAlarmInternationalSent;
          this.showCostLimit = true;
        } catch
            (error) {
          logger.error(error)
          this.actualCostNational = -1;
          this.actualCostInternational = -1;
          showAlert(error.message)
        }
        this.isLoading = false;
      }
    }
    ,
    isSelectedPeriode(periode) {
      logger.debug("isSelectedPeriode called with " + periode);
      let result = this.costPeriode == periode;
      logger.debug(this.costPeriode + "==" + periode + "->" + result);
      return result;
    }
    ,

    validateCostEmail() {
      if (this.costEmail == undefined) {
        return true;
      }
      let emails = this.costEmail.split(",");
      for (let i = 0; i < emails.length; i++) {
        if (!validateEmail(emails[i])) {
          return false;
        }
      }
      emails
      return true;
    }
    ,
    validateCostAlarmNational() {
      return Number(this.costAlarmNational) <= Number(this.costLimitNational);
    }
    ,
    validateCostAlarmInternational() {
      return Number(this.costAlarmInternational) <= Number(this.costLimitInternational);
    }
    ,
    validateForm() {
      return this.validateCostEmail() && this.validateCostAlarmNational() && this.validateCostAlarmInternational();
    }
    ,
    addOwnersEmail() {
      this.costEmail = this.costEmail ? this.costEmail + "," + userService.getViewUserEmail() : userService.getViewUserEmail();
    }
    ,
    async save() {
      await costLimitService.updateCostLimit(this.webId, this.costAlarmNational, this.costLimitNational, this.costAlarmInternational, this.costLimitInternational, this.costPeriode, this.costEmail, this.costEmail);
      showSuccess("New limits are successfully saved.");
    }
  }
}
</script>

<style scoped>
.loader-bar--progress > .indicator {
  height: 40px;
}

.loader-bar--progress > .indicator::after {
  height: 40px;
}

.cost-limit-bar-title {
  font-size: 24px;
  font-weight: bold;
}

.cost-limit-bar {
  height: 40px;
}

.cost-alarm {
  background-color: orange !important;
}

.cost-limit {
  background-color: red !important;
}

.infoCostAlarm{
  color: orange ;
}
.infoCostLimit{
  color: red ;
}
</style>